<template>
    <div>
        <div v-if="!pageIndexApiDataIsLoading">
            <company-licence-component/>

            <div class="row">
                <div class="col-md-12 m-b-0">
                  <router-link class="btn btn-white m-r-5 text-orange" to="/sales"><i class="fa fa-chart-bar fa-fw fa-lg text-orange"></i></router-link>
                  <router-link class="btn btn-white m-r-5" to="/dashboard/daily-report"><i class="fa fa-calendar fa-fw fa-lg"></i> Rapport Journalier</router-link>
                </div>
            </div>

            <!--<h1 class="page-header">Suivi des ventes <small class="lead"> Un apperçu de quelques chiffres clés à l'instant.</small></h1>-->
            <hr class="bg-grey-lighter"/>

            <div class="row m-b-5">
                <div class="col-md-12 m-b-0">

                </div>
            </div>

            <div v-if="pageIndexApiData != null">
              <div class="row">
                <div class="col-lg-3 col-md-6">
                  <div class="widget widget-stats bg-gradient-teal">
                    <div class="stats-icon stats-icon-lg"><i class="fa fa-clock fa-fw"></i></div>
                    <div class="stats-info">
                      <h3 class="f-s-17 f-w-300 text-white"><b>CHIFFRE D'AFF. DU JOUR</b></h3>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.credit_sales_today|formatMoney}}
                          <small>
                            <small> A TERME</small>
                          </small>
                        </small>
                      </p>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.cash_sales_today|formatMoney}}
                          <small>
                            <small> EN ESPECE</small>
                          </small>
                        </small>
                      </p>
                      <br/>
                      <div class="stats-progress progress">
                        <div class="progress-bar" style="width: 100%;"></div>
                      </div>
                      <p class="text-right">
                        {{pageIndexApiData.total_sales_today|formatMoney}}
                        <small> {{appCurrency}}</small>
                      </p>
                    </div>
                    <div class="stats-link">
                      <a href="javascript:;"><b>CHIFFRE D'AFFAIRES DU JOUR</b>
                        <!--<i class="fa fa-chart-line"></i>--></a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="widget widget-stats bg-gradient-orange">
                    <div class="stats-icon stats-icon-lg"><i class="fa fa-dollar-sign fa-fw"></i></div>
                    <div class="stats-info">
                      <h3 class="f-s-17 f-w-300 text-white"><b>RECETTE DU JOUR</b></h3>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.order_cash_payments_today|formatMoney}}
                          <small>
                            <small> VENTES</small>
                          </small>
                        </small>
                      </p>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.order_cash_outs_today|formatMoney}}
                          <small>
                            <small> RECOUV.</small>
                          </small>
                        </small>
                      </p>
                      <br/>
                      <div class="stats-progress progress">
                        <div class="progress-bar" style="width: 100%;"></div>
                      </div>
                      <p class="text-right">
                        {{pageIndexApiData.total_payments_today|formatMoney}}
                        <small> {{appCurrency}}</small>
                      </p>
                    </div>
                    <div class="stats-link">
                      <a href="javascript:;"><b>RECETTE DU JOUR</b>
                        <!--<i class="fa fa-chart-line"></i>--></a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="widget widget-stats bg-gradient-blue">
                    <div class="stats-icon stats-icon-lg"><i class="fa  fa-calendar fa-fw"></i></div>
                    <div class="stats-info">
                      <h3 class="f-s-17 f-w-300 text-white"><b>CHIFFRE D'AFF. DU MOIS</b></h3>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.credit_sales_current_month|formatMoney}}
                          <small>
                            <small> A TERME</small>
                          </small>
                        </small>
                      </p>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.cash_sales_current_month|formatMoney}}
                          <small>
                            <small> EN ESPECE</small>
                          </small>
                        </small>
                      </p>
                      <br/>
                      <div class="stats-progress progress">
                        <div class="progress-bar" style="width: 100%;"></div>
                      </div>
                      <p class="text-right">
                        {{pageIndexApiData.total_sales_current_month|formatMoney}}
                        <small> {{appCurrency}}</small>
                      </p>
                    </div>
                    <div class="stats-link">
                      <a href="javascript:;"><b>CHIFFRE D'AFFAIRES DU MOIS</b>
                        <!--<i class="fa fa-chart-line"></i>--></a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="widget widget-stats bg-gradient-red">
                    <div class="stats-icon stats-icon-lg"><i class="fa fa-euro-sign fa-fw"></i></div>
                    <div class="stats-info">
                      <h3 class="f-s-17 f-w-300 text-white"><b>RECETTE DU MOIS</b></h3>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.order_cash_payments_current_month|formatMoney}}
                          <small>
                            <small> VENTES</small>
                          </small>
                        </small>
                      </p>
                      <p class="text-right">
                        <small>
                          {{pageIndexApiData.order_cash_outs_current_month|formatMoney}}
                          <small>
                            <small> RECOUV.</small>
                          </small>
                        </small>
                      </p>
                      <br/>
                      <div class="stats-progress progress">
                        <div class="progress-bar" style="width: 100%;"></div>
                      </div>
                      <p class="text-right">
                        {{pageIndexApiData.total_payments_current_month|formatMoney}}
                        <small> {{appCurrency}}</small>
                      </p>
                    </div>
                    <div class="stats-link">
                      <a href="javascript:;"><b>RECETTE DU MOIS</b>
                        <!--<i class="fa fa-chart-line"></i>--></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="panel-loader" v-else><span class="spinner-small"></span></div>

    </div>
</template>

<script>
    import pageApi from '../../store/api/sales/sales-dashboard-page-api'
    import LocalStorage from "../../store/local-storage";
    import CompanyLicenceComponent from '../../components/app/base/CompanyLicenceComponent.vue'

    export default {
        name: 'sales-dashboard-page-component',
        components: {
            CompanyLicenceComponent,
        },
        props: {},
        watch: {},
        computed: {},
        methods: {
            //Initialization Methods
            loadPageScripts() {
            },

            //Other Methods
            async getPageIndexApiData() {
                this.pageIndexApiDataIsLoading = true;
                this.pageIndexApiDataErrorMessage = null;
                try {
                    const response = await pageApi.getIndexData();
                    //console.log(response);
                    this.pageIndexApiData = response.data;
                    this.pageIndexApiDataIsLoading = false;
                    this.pageIndexApiDataErrorMessage = null;
                } catch (error) {
                    if (error.response) {
                        //Server responded with a status code that is NOT in the HTTP 200 range
                        //console.log("Headers", error.response.headers);
                        //console.log("Status Code", error.response.status);
                        //console.log("Response Data", error.response.data);
                        if (error.response.status === 401 || error.response.status === 403 || error.response.status === 419) {
                            this.pageIndexApiDataIsLoading = false;
                            this.pageIndexApiDataErrorMessage = error.response.data.message;
                            LocalStorage.clearSessionData();
                            this.$router.push('login');
                        } else {
                            this.pageIndexApiDataIsLoading = false;
                            this.pageIndexApiDataErrorMessage = error.response.data.message;
                            //
                            this.$swal({
                                icon: 'error',//'info','success','warning','error','question',
                                toast: true,
                                position: 'bottom-end',
                                timer: 3000,
                                showConfirmButton: false,
                                title: 'HTTP ' + error.response.status,
                                text: error.response.data.message,
                            })
                        }
                    } else {
                        this.pageIndexApiDataIsLoading = false;
                        this.pageIndexApiDataErrorMessage = error.message;
                        //
                        this.$swal({
                            icon: 'error',//'info','success','warning','error','question',
                            toast: true,
                            position: 'bottom-end',
                            timer: 3000,
                            showConfirmButton: false,
                            //title: error.message
                            text: error.message,
                        })
                    }
                }
            },
        },
        data: function () {
            return {
                appName: window.appConfig.appName,
                appCurrency: window.appConfig.appCurrency,
                intervalId01: 0,

                //API Data
                //
                pageIndexApiData: null,
                pageIndexApiDataIsLoading: false,
                pageIndexApiDataErrorMessage: null,
            };
        },
        created: function () {
            this.getPageIndexApiData();
        },
        mounted: function () {
            this.loadPageScripts();
        },
        beforeDestroy: function () {
        },
    }
</script>
